import axios from "axios";
import Env from "@/logics/Envs.js";

export default async function (classId, plans) {
    try {
        const toSend = new FormData();
        toSend.append("classId", classId);
        toSend.append("json", JSON.stringify(plans));

        const res = await axios.post(Env.apiPath + "updateClassPay", toSend);
        return res.data.error;
    } catch (err) {
        return err;
    }
}